var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 4.92441V11.3994C12.1406 11.5154 12.0945 11.6267 12.0125 11.7088C11.9304 11.7908 11.8192 11.8369 11.7031 11.8369H2.29688C2.18084 11.8369 2.06956 11.7908 1.98752 11.7088C1.90547 11.6267 1.85938 11.5154 1.85938 11.3994V1.99316C1.85938 1.87713 1.90547 1.76585 1.98752 1.6838C2.06956 1.60176 2.18084 1.55566 2.29688 1.55566H9.10875",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26128 8.48091L4.12128 9.70372C4.1182 9.731 4.12126 9.75862 4.13025 9.78455C4.13925 9.81048 4.15393 9.83407 4.17324 9.85359C4.19254 9.8731 4.21597 9.88804 4.2418 9.89731C4.26764 9.90658 4.29522 9.90995 4.32253 9.90716L5.53878 9.76716C5.57999 9.76206 5.6184 9.74362 5.64815 9.71466L12.0094 3.32935C12.0432 3.29562 12.07 3.25555 12.0883 3.21145C12.1066 3.16734 12.116 3.12006 12.116 3.07232C12.116 3.02457 12.1066 2.97729 12.0883 2.93318C12.07 2.88908 12.0432 2.84901 12.0094 2.81528L11.1891 1.9906C11.1206 1.9222 11.0278 1.88379 10.931 1.88379C10.8342 1.88379 10.7413 1.9222 10.6728 1.9906L4.31159 8.37372C4.28331 8.40282 4.2656 8.44056 4.26128 8.48091Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81519 2.85254L11.1342 4.20879",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolveIcon);
export default __webpack_public_path__ + "static/media/Solve-icon.22ded8ae5a8d3ee6190680375462fc5e.svg";
export { ForwardRef as ReactComponent };